export const sidebarUtil = {
	sideBar: [
		{
			key: '1',
			label: 'Profile',
			icon: 'allSvgIcon'
		}
	]
};
